export const ANALYTICS_EVENTS = {
    SESSION_STARTED: "session_started",
    FEATURE_STARTED: "feature_started",
    SCROLLED: "scrolled",
    CTA_CLICKED: "cta_clicked",
    ITEM_SELECTED: "item_selected",
    /** Fired when guest or logged-in post generation succeeds or fails */
    POST_GENERATED: "post_generated",
    /** GA4 recommended auth events (use these exact names in gtag) */
    LOGIN: "login",
    SIGN_UP: "sign_up",
    LOGOUT: "logout",
};

export const ANALYTICS_AUTH_METHODS = {
    EMAIL: "email",
    GOOGLE: "google",
};

export const ANALYTICS_FEATURES = {
    AUTH: "auth",
    CAMPAIGN_BUILDER: "campaign_builder",
    CONTENT_AI: "content_ai",
};

/** Where campaign_builder / content_ai was started from */
export const ANALYTICS_ENTRY_POINTS = {
    DASHBOARD_BANNER: "dashboard_banner",
    DASHBOARD_OPPORTUNITY: "dashboard_opportunity",
    CONTENT_AI: "content_ai",
    NICHE_LANDING: "niche_landing",
    SIDEBAR: "sidebar",
    WIZARD: "wizard",
    DIRECT: "direct",
};

/** Scroll / section identifiers for the scrolled event */
export const ANALYTICS_SECTIONS = {
    OPPORTUNITIES: "opportunities",
    TONE: "tone",
    TOPIC: "topic",
    TARGET: "target",
};

export const ANALYTICS_ITEM_TYPES = {
    OPPORTUNITY: "opportunity",
    HASHTAG: "hashtag",
};

export const ANALYTICS_GENERATION_MODES = {
    GUEST: "guest",
    COMBINED: "combined",
};

/** Onboarding milestone — fired as its own event name */
export const ANALYTICS_DISCOVERY_STEPS = {
    PROFILE_CREATED: "profile_created",
};

/** `cta_clicked` parameter values — single catalog for funnels & GA4 exploration */
export const ANALYTICS_CTAS = {
    GET_STARTED: "get_started",
    NAV_MENU: "nav_menu",
    NAV_LOGO: "nav_logo",
    NAV_HOME: "nav_home",
    NAV_LOGIN: "nav_login",
    NAV_LOGOUT: "nav_logout",
    NAV_UPGRADE: "nav_upgrade",
    NAV_PLAN_PILL: "nav_plan_pill",
    FOOTER_TERMS: "footer_terms",
    FOOTER_PRIVACY: "footer_privacy",
    CREATE_FIRST_POST: "create_first_post",
    REGISTER_BUSINESS: "register_business",
    START_CAMPAIGN: "start_campaign",
    GENERATE_POSTS: "generate_posts",
    VIEW_ALL_OPPORTUNITIES: "view_all_opportunities",
    SETUP_PROFILE: "setup_profile",
    VIEW_PLANS: "view_plans",
    UPGRADE_PLAN: "upgrade_plan",
    AUTH_LOGIN: "auth_login",
    AUTH_REGISTER: "auth_register",
    NICHE_OTHER: "niche_other",
};

export function nicheCtaId(nicheId) {
    return `niche_${nicheId}`;
}

export function subscribeCtaId(planName) {
    const slug = String(planName ?? "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "_");
    return slug ? `subscribe_${slug}` : "subscribe_plan";
}
